export default __webpack_public_path__ + "static/media/Prarie-Gayfeather_R3.6cc99b61.png";